import Vue from 'vue'
import VueRouter from 'vue-router'

Vue.use(VueRouter)

const routes = [
  {
    // 重定向
    path: '/',
    redirect: '/hangzhou'
  },
  {
    path: '/hangzhou',
    // name: 'Hangzhou2025',
    component: () => import(/* webpackChunkName: "about" */ '../views/Hangzhou2025.vue'),
    // props: {},
    // meta: { title: 'AI杭州 码动未来', desc: 'AI模型智能体创新大赛' },
    meta: { title: 'AI模型智能体创新大赛', desc: '' },
    children: [
      {
        path: '',
        name: 'Hangzhou2025',
        component: () => import(/* webpackChunkName: "about" */ '../views/second/Hangzhou2025_home.vue'),
        // props: true,
        // props: (route) => ({
        //   ...route.parentProps,
        // }),
        meta: { title: 'AI模型智能体创新大赛', desc: '' },
      },
      {
        path: 'track',
        name: 'Hangzhou2025Track',
        component: () => import(/* webpackChunkName: "about" */ '../views/second/Hangzhou2025_track.vue'),
        props: (route) => ({
          // ...route.parentProps,
          id: route.query.id
        }),
        meta: { title: 'AI模型智能体创新大赛', desc: ' - 赛道说明' }
      }
    ]
  }
]

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes
})

// eslint-disable-next-line no-unused-vars
router.beforeEach((to, from, next) => {
  // console.log('routerBeforeEach ', to, from)
  if (to.meta && to.meta.title) {
    document.title = to.meta.title + to.meta.desc
  }
  next()
})

export default router
